module.exports = __webpack_public_path__ + "img/esquemaA.6f4d5920.svg";